import { loadScripts } from '@uvocore-front/utils';

window.addEventListener('load', () => {
  if (window.innerWidth >= 1024) {
    loadScripts('/assets/js/notifyWidget.min.js').then(() => {
      window.NotifyWidget({ container: '.NotifyWidget__popup' });
    });
  }
});
